import { IAnnouncementProps } from '../interface';

export const STATUS_TYPE = {
  SUCCESS: 'success',
  WARNING: 'warning',
  INFO: 'info',
  ERROR: 'error',
};

export const HTML_MESSAGE =
  '<div class="alert-container"><p>Replace this <a href="https://example.com" target="_blank"> message  </a> with author content</p> </div>';

export const SUCCESS_MSG = 'Success message';
export const ERROR_MSG = 'Error message';
export const ALERT_MSG = 'Alert message';
export const INFO_MSG = 'Information message';

export const ANNOUNCEMENT_DBINDEX = 'announcement_messages';
export const ANNOUNCEMENT_STORE = 'announcement';

export const ANNOUNCEMENT_MESSAGES: IAnnouncementProps[] = [
  {
    id: 'UID_483983',
    isPersistent: true,
    statusType: STATUS_TYPE.SUCCESS,
    message: HTML_MESSAGE,
  },
  {
    id: 'UID_483932',
    isPersistent: false,
    statusType: STATUS_TYPE.INFO,
    message: HTML_MESSAGE,
    expiryDate: '05/20/2024',
  },
  {
    id: '6543-44',
    isPersistent: false,
    statusType: STATUS_TYPE.INFO,
    message: HTML_MESSAGE + STATUS_TYPE.ERROR,
    expiryDate: '04/20/2024',
  },
  {
    id: 'UID-654',
    isPersistent: false,
    statusType: STATUS_TYPE.WARNING,
    message: HTML_MESSAGE + STATUS_TYPE.WARNING,
    expiryDate: '',
  },
];

export const ANNOUNCEMENT_MESSAGES_2 = [
  {
    id: 'UID_483932',
    isPersistent: false,
    statusType: STATUS_TYPE.INFO,
    message: HTML_MESSAGE,
  },
];

export const announcements = [
  {
    id: '1',
    isPersistent: false,
    statusType: STATUS_TYPE.INFO,
    message: HTML_MESSAGE + STATUS_TYPE.INFO,
  },
  {
    id: '6543-43',
    isPersistent: false,
    statusType: STATUS_TYPE.ERROR,
    message: HTML_MESSAGE + STATUS_TYPE.ERROR,
    expiryDate: '05/20/2024',
  },
  {
    id: '6543-44',
    isPersistent: false,
    statusType: STATUS_TYPE.INFO,
    message: HTML_MESSAGE + STATUS_TYPE.ERROR,
    expiryDate: '04/20/2024',
  },
  {
    id: '2',
    isPersistent: true,
    statusType: STATUS_TYPE.SUCCESS,
    message: HTML_MESSAGE + STATUS_TYPE.SUCCESS,
  },
  {
    id: 'UID-654',
    isPersistent: false,
    statusType: STATUS_TYPE.WARNING,
    message: HTML_MESSAGE + STATUS_TYPE.WARNING,
    expiryDate: '',
  },
];
